export default __webpack_public_path__ + "locales/de/FormGallery.json?hash=6c3d93eb634509919801589e47190d2b";